(function () {

  'use strict';

  // ─────────────────────────────────────────────────────────────
  // PRICE CACHE
  // ─────────────────────────────────────────────────────────────

  var priceCache = {};
  var addonVariantCache = {};

  // ─────────────────────────────────────────────────────────────
  // LOAD ADDON PRICES
  // ─────────────────────────────────────────────────────────────

  function loadAddonPrices(callback) {

    var handles = [];

    document
      .querySelectorAll('[data-price-handle], [data-addon-price-label]')
      .forEach(function (el) {

        var handle =
          el.dataset.priceHandle ||
          el.dataset.addonPriceLabel;

        if (
          handle &&
          handles.indexOf(handle) === -1
        ) {
          handles.push(handle);
        }
      });

    if (handles.length === 0) {
      callback();
      return;
    }

    var loaded = 0;

    handles.forEach(function (handle) {

      fetch('/products/' + handle + '.js')

        .then(function (r) {
          return r.json();
        })

        .then(function (product) {

          if (
            product &&
            product.variants &&
            product.variants[0]
          ) {

            // Preis speichern
            priceCache[handle] =
              product.variants[0].price;

            // Variant ID speichern
            addonVariantCache[handle] =
              product.variants[0].id;
          }
        })

        .catch(function () {})

        .finally(function () {

          loaded++;

          if (loaded === handles.length) {
            callback();
          }
        });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // MONEY FORMAT
  // ─────────────────────────────────────────────────────────────

  function formatMoney(cents) {

    // Immer "<Betrag> <Symbol>" (Symbol hinter dem Betrag, ein Leerzeichen dazwischen) -
    // unabhängig von der Seitensprache, damit es exakt zum serverseitig via
    // snippets/money.liquid gerenderten Preis passt. Das Zahlenformat (Komma- vs.
    // Punkt-Dezimaltrennzeichen) und das Symbol hängen von der aktiven Presentment-Currency
    // ab, nicht von der Storefront-Sprache - z.B. immer "179,00 €" für EUR und
    // "259.00 CHF" für CHF, unabhängig davon ob die Seite gerade auf DE/EN/FR steht. Bekannte
    // Märkte dieses Shops sind hier fest zugeordnet; ein neuer Markt/eine neue Currency
    // braucht ggf. einen weiteren Eintrag in numberLocale.
    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

    var numberLocale = currency === 'CHF' ? 'de-CH' : 'de-DE';

    var symbol =
      (typeof themeCurrencySymbol !== 'undefined' && themeCurrencySymbol) || '€';

    var formatted = Math.abs(cents / 100).toLocaleString(
      numberLocale,
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    );

    return formatted + ' ' + symbol;
  }

  // ─────────────────────────────────────────────────────────────
  // PRICE LABELS
  // ─────────────────────────────────────────────────────────────

  function updatePriceLabels() {

    document
      .querySelectorAll('[data-addon-price-label]')
      .forEach(function (el) {

        var handle =
          el.dataset.addonPriceLabel;

        var cents =
          priceCache[handle];

        if (cents == null) return;

        var prefix =
          cents < 0
            ? '\u00a0(\u2212\u00a0'
            : '\u00a0(+\u00a0';

        el.textContent =
          prefix +
          formatMoney(cents) +
          ')';
      });
  }

  // ─────────────────────────────────────────────────────────────
  // LIVE PRODUCT PRICE
  // ─────────────────────────────────────────────────────────────

  function updateProductPrice() {

    var priceEl = document.querySelector(
      '.price-list.price-list--product sale-price'
    );

    if (!priceEl) return;

    var variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (!variantInput) return;

    var variantId = variantInput.value;

    fetch('/variants/' + variantId + '.js')

      .then(function (r) {
        return r.json();
      })

      .then(function (variant) {

        var total = variant.price;

        document
          .querySelectorAll(
            '[data-price-handle]:checked'
          )
          .forEach(function (input) {

            var handle =
              input.dataset.priceHandle;

            if (
              handle &&
              priceCache[handle]
            ) {

              total += priceCache[handle];
            }
          });

        var srOnly =
          priceEl.querySelector('.sr-only');

        priceEl.innerHTML =
          (srOnly ? srOnly.outerHTML : '') +
          formatMoney(total);
      });
  }

  // ─────────────────────────────────────────────────────────────
  // LABEL HELPERS
  // ─────────────────────────────────────────────────────────────

  function getLabelFor(input) {

    return input.id
      ? document.querySelector(
          'label[for="' + input.id + '"]'
        )
      : null;
  }

  function setActiveLabel(input) {

    var name = input.name;

    try {

      document
        .querySelectorAll(
          'input[name="' + CSS.escape(name) + '"]'
        )
        .forEach(function (i) {

          var lbl = getLabelFor(i);

          if (lbl) {
            lbl.classList.remove('is-selected');
          }
        });

    } catch (e) {}

    var lbl = getLabelFor(input);

    if (lbl) {
      lbl.classList.add('is-selected');
    }
  }

  // ─────────────────────────────────────────────────────────────
  // INITIAL DEFAULT STATES
  // ─────────────────────────────────────────────────────────────

  function initializeSelectedStates(wrapper) {

    wrapper
      .querySelectorAll(
        'input[type="radio"]:checked'
      )
      .forEach(function (input) {

        setActiveLabel(input);

        // Dropdown Label
        if (input.dataset.dropdownLabel) {

          var target = document.getElementById(
            input.dataset.dropdownLabel
          );

          if (target) {
            target.textContent = input.value;
          }
        }

        // Color Label
        var fieldset =
          input.closest('fieldset');

        if (fieldset) {

          var colorSelected =
            fieldset.querySelector(
              '[data-addon-color-selected]'
            );

          if (colorSelected) {

            var lbl = getLabelFor(input);

            if (lbl) {

              colorSelected.textContent =
                lbl.title || input.value;
            }
          }
        }
      });
  }

  // ─────────────────────────────────────────────────────────────
  // DEPENDENCIES
  // ─────────────────────────────────────────────────────────────

  function updateDependencies(wrapper) {

    var currentValues = {};

    wrapper
      .querySelectorAll(
        'input[data-addon-key]:checked'
      )
      .forEach(function (input) {

        currentValues[
          input.dataset.addonKey
        ] = input.dataset.addonValue;
      });

    wrapper
      .querySelectorAll('[data-depends-on]')
      .forEach(function (el) {

        var parts =
          el.dataset.dependsOn.split(':');

        var depKey = parts[0];
        var depVal = parts[1];

        var cur =
          currentValues[depKey] || '';

        el.style.display =
          (cur === depVal)
            ? ''
            : 'none';
      });
  }

  // ─────────────────────────────────────────────────────────────
  // TASCHE → VARIANT PICKER
  // ─────────────────────────────────────────────────────────────

  function syncTascheToVariantPicker(addonValue) {

    var variantPicker =
      document.querySelector(
        'variant-picker'
      );

    if (!variantPicker) return;

    var nativeInputs =
      variantPicker.querySelectorAll(
        'fieldset[aria-hidden="true"] input[data-option-position]'
      );

    var targetIndex =
      addonValue === 'mit'
        ? 0
        : 1;

    var target =
      nativeInputs[targetIndex];

    if (target) {

      target.checked = true;

      target.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  // ─────────────────────────────────────────────────────────────
  // STOFF PROPERTY
  // ─────────────────────────────────────────────────────────────

  function updateStoffCartProperty(wrapper) {

    var form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    form
      .querySelectorAll(
        'input[data-addon-stoff-property]'
      )
      .forEach(function (el) {
        el.remove();
      });

    var tascheInput =
      wrapper.querySelector(
        'input[data-addon-key="tasche"]:checked'
      );

    var tascheVal =
      tascheInput
        ? tascheInput.dataset.addonValue
        : 'mit';

    if (tascheVal === 'ohne') return;

    var stoffWrapper =
      wrapper.querySelector(
        '[data-addon-key="stoffe"]'
      );

    if (
      !stoffWrapper ||
      stoffWrapper.style.display === 'none'
    ) {
      return;
    }

    var checkedStoff =
      wrapper.querySelector(
        '.fabric-input:checked'
      );

    if (
      !checkedStoff ||
      !checkedStoff.value
    ) {
      return;
    }

    var stoffInput =
      document.createElement('input');

    stoffInput.type = 'hidden';
    stoffInput.name = checkedStoff.name;
    stoffInput.value = checkedStoff.value;

    stoffInput.dataset.addonStoffProperty =
      'true';

    form.appendChild(stoffInput);
  }

  // ─────────────────────────────────────────────────────────────
  // AJAX ADD TO CART (ADDONS)
  // ─────────────────────────────────────────────────────────────
  //
  // Das Haupt-Produkt wird ganz normal vom nativen <product-form>
  // Handler (theme.js) hinzugefügt - wir greifen hier NICHT in den
  // Submit ein (das würde das Produkt doppelt in den Warenkorb legen).
  //
  // Sobald der native Handler erfolgreich war (Event "variant:add"),
  // fügen wir die gewählten Addon-Produkte in einem zweiten Request
  // hinzu und verknüpfen sie über die Property "_addon_of" mit der
  // Cart-Line des Hauptprodukts, damit der Cart Drawer sie als Zusatz
  // darstellen kann.

  function setupAddonCart() {

    var form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    form.addEventListener(
      'variant:add',
      function (e) {

        var mainItem =
          e.detail &&
          e.detail.items &&
          e.detail.items[0];

        if (!mainItem) return;

        var addonItems = [];

        document
          .querySelectorAll(
            '[data-price-handle]:checked'
          )
          .forEach(function (input) {

            var handle =
              input.dataset.priceHandle;

            var variantId =
              addonVariantCache[handle];

            if (!variantId) return;

            addonItems.push({
              id: variantId,
              quantity: 1,
              properties: {
                '_addon_of': mainItem.key
              }
            });
          });

        if (addonItems.length === 0) return;

        fetch('/cart/add.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({
            items: addonItems
          })
        })

          .then(function (r) {
            return r.json();
          })

          .then(function () {

            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh',
                {
                  bubbles: true
                }
              )
            );
          })

          .catch(function () {});
      }
    );
  }

  // ─────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────

  function init() {

    var wrapper =
      document.querySelector(
        '[data-addons-wrapper]'
      );

    if (!wrapper) return;

    initializeSelectedStates(wrapper);

    updateDependencies(wrapper);

    updatePriceLabels();

    updateProductPrice();

    updateStoffCartProperty(wrapper);

    wrapper.addEventListener(
      'change',
      function (e) {

        var input = e.target;

        if (
          !input.matches(
            'input[type="radio"]'
          )
        ) {
          return;
        }

        // Active
        setActiveLabel(input);

        // Live Price
        updateProductPrice();

        // Dropdown Label
        if (
          input.dataset.dropdownLabel
        ) {

          var target =
            document.getElementById(
              input.dataset.dropdownLabel
            );

          if (target) {
            target.textContent =
              input.value;
          }
        }

        // Color Label
        if (input.dataset.addonKey) {

          var fieldset =
            input.closest('fieldset');

          if (fieldset) {

            var colorSelected =
              fieldset.querySelector(
                '[data-addon-color-selected]'
              );

            if (colorSelected) {

              var lbl =
                getLabelFor(input);

              if (lbl) {

                colorSelected.textContent =
                  lbl.title ||
                  input.value;
              }
            }
          }
        }

        // Fabric Label
        if (
          input.classList.contains(
            'fabric-input'
          )
        ) {

          var fabricSelected =
            document.querySelector(
              '[data-fabric-selected]'
            );

          if (fabricSelected) {
            fabricSelected.textContent =
              input.value;
          }
        }

        // Tasche Sync
        if (
          input.dataset.addonKey ===
          'tasche'
        ) {

          syncTascheToVariantPicker(
            input.dataset.addonValue
          );
        }

        updateDependencies(wrapper);

        updateStoffCartProperty(wrapper);
      }
    );
  }

  // ─────────────────────────────────────────────────────────────
  // DOM READY
  // ─────────────────────────────────────────────────────────────

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      loadAddonPrices(function () {

        updatePriceLabels();

        init();

        setupAddonCart();

        setTimeout(
          updatePriceLabels,
          500
        );

        setTimeout(
          updatePriceLabels,
          1500
        );
      });
    }
  );

  // Preis nach einem Variantenwechsel (z.B. Größe) neu berechnen, damit ein
  // gewählter Aufpreis nicht verloren geht. Ein Variantenwechsel kann außerdem
  // den "variant_picker" Block (inkl. allem was daneben im selben Block liegt,
  // z.B. der Maßanfertigung-Button) per Teil-Rerender frisch neu rendern -
  // dabei gehen bereits gesetzte Preis-Labels ([data-addon-price-label]) auf
  // den neuen Elementen verloren, deshalb hier auch updatePriceLabels() erneut
  // aufrufen (nutzt den schon geladenen Preis-Cache, kein erneuter Fetch nötig).
  document.addEventListener(
    'variant:change',
    function () {
      updateProductPrice();
      updatePriceLabels();
    }
  );

  // Preis-Aufpreise gibt es nicht nur innerhalb von [data-addons-wrapper]
  // (z.B. Paspelierung, Kapuze), sondern auch außerhalb davon, etwa bei den
  // Stoff-Swatches (snippets/fabric-swatch-block.liquid). Dieser Listener
  // deckt jede Radio-Gruppe ab, die IRGENDWO einen Aufpreis-Wert enthält -
  // nicht nur wenn die NEU gewählte Option selbst einen Aufpreis hat. Sonst
  // bleibt der Aufpreis "hängen", wenn man von einem Aufpreis-Stoff zurück
  // zu einem Stoff ohne Aufpreis wechselt (dessen <input> hat kein
  // data-price-handle, das change-Ziel würde also nicht matchen).
  document.addEventListener(
    'change',
    function (e) {

      var input = e.target;

      if (
        !input.matches('input[type="radio"]') ||
        !input.name
      ) {
        return;
      }

      var hasPricedSibling;

      try {

        hasPricedSibling = document.querySelector(
          'input[name="' +
          CSS.escape(input.name) +
          '"][data-price-handle]'
        );

      } catch (err) {
        return;
      }

      if (!hasPricedSibling) return;

      updateProductPrice();
    }
  );

})();